/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DentalPlan/view.blocks to change it.
import Choice from 'DesignSystem/Choice/index'
import Question from 'DesignSystem/Question/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DentalPlan({
  children,
  viewPath = "/App/Form/Data/ProvideData/DentalPlan",
  focusArea,
  onClick,
  value
  
}) {
  return (<React.Fragment
>
<div
  data-testid="DentalPlan.Vertical"
  data-view-path={viewPath}
 ref={focusArea}
 className="views-block"
>
<Question
  viewPath={`${viewPath}/Question`}
 marginTop={8}
 text="Choose your dental plan to find a clinic that fits your insurance needs."
/>
<Choice
  viewPath={`${viewPath}/Choice`}
 id="PRIVATE_INSURANCE"
 onClick={onClick}
 selected={value}
 text="Private Insurance/No Insurance"
/>
<Choice
  viewPath={`${viewPath}/Choice`}
 id="MEDICAID"
 onClick={onClick}
 selected={value}
 text="Medicaid"
/>
</div>
{children}
</React.Fragment>)
}